import { SuggestionsApi } from '@/api/suggestions/api'

export const suggestionsApi = new SuggestionsApi()
